export default __webpack_public_path__ + "static/media/clutch-ignition-protectors.188e4e5f.glb";